import {
	Flex,
	FormControl,
	FormLabel,
	Grid,
	GridItem,
	Heading,
	Input,
	Text,
} from "@chakra-ui/react";
import React from "react";

const SubmitPropertyForm2 = (props) => {
	const { register, errors } = props;
	return (
		<>
			<Heading w="100%" textAlign={"center"} fontWeight="normal" mb="2%">
				Contact Information
			</Heading>
			<Grid templateColumns={"repeat(2, 1fr)"} gap={5}>
				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>First Name</FormLabel>
						<Input
							placeholder="Frist Name"
							{...register("firstName", {
								required: "First name is required",
							})}
						/>
						{errors.firstName && (
							<Text color="red">{errors.firstName.message}</Text>
						)}
					</FormControl>
				</GridItem>

				<GridItem colSpan={{ base: 2, lg: 1 }}>
					<FormControl>
						<FormLabel>Last Name</FormLabel>
						<Input
							placeholder="Last Name"
							{...register("lastName", {
								required: "Last name is required",
							})}
						/>
						{errors.lastName && (
							<Text color="red">{errors.lastName.message}</Text>
						)}
					</FormControl>
				</GridItem>
			</Grid>

			<FormControl>
				<FormLabel mt="2%">Email</FormLabel>
				<Input
					type="email"
					w="full"
					rounded="md"
					placeholder="Email"
					{...register("email", {
						required: "Email is required",
					})}
				/>
				{errors.email && <Text color="red">{errors.email.message}</Text>}
			</FormControl>

			<FormControl as={GridItem} colSpan={[6, 3, null, 2]}>
				<FormLabel mt="2%">Phone Number</FormLabel>
				<Input
					{...register("phoneNumber", {
						required: "phoneNumber is required",
					})}
					w="full"
					rounded="md"
					placeholder="Phone Number"
				/>
				{errors.phoneNumber && (
					<Text color="red">{errors.phoneNumber.message}</Text>
				)}
			</FormControl>
		</>
	);
};

export default SubmitPropertyForm2;
